import { rockApi, unwrapRockResponse } from "./rockApiClient";

function normalizeV1TaskStatus(task) {
  if (!task || typeof task !== "object") return task;
  // For legacy (v1) tasks, treat "done" as "completed" to keep status consistent.
  if (task.flow !== "v2" && task.status === "done") {
    return { ...task, status: "completed" };
  }
  return task;
}

export const rockTasksApi = {
  async getTasksList({
    page = 1,
    items_per_page = 20,
    id,
    task_id,
    device_id,
    source,
    status,
    flow,
    is_vpn,
    endpoint,
    platform,
    fallback_used,
    from,
    to,
    app_version,
    country_code,
    language_code,
    rc_app_user_id,
    email,
    os,
    os_version
  } = {}) {
    const params = { page, items_per_page };
    if (id) params.id = id;
    if (task_id) params.task_id = task_id;
    if (device_id) params.device_id = device_id;
    if (source) params.source = source;
    if (status) params.status = status;
    if (flow) params.flow = flow;
    if (is_vpn !== undefined && is_vpn !== "") params.is_vpn = is_vpn;
    if (endpoint) params.endpoint = endpoint;
    if (platform) params.platform = platform;
    if (fallback_used !== undefined && fallback_used !== "") params.fallback_used = fallback_used;
    if (from) params.from = from;
    if (to) params.to = to;
    if (app_version) params.app_version = app_version;
    if (country_code) params.country_code = country_code;
    if (language_code) params.language_code = language_code;
    if (rc_app_user_id) params.rc_app_user_id = rc_app_user_id;
    if (email) params.email = email;
    if (os) params.os = os;
    if (os_version) params.os_version = os_version;
    const resp = await rockApi.get("/rocks/identify-tasks", { params });
    const data = unwrapRockResponse(resp);
    if (data?.items && Array.isArray(data.items)) {
      return { ...data, items: data.items.map(normalizeV1TaskStatus) };
    }
    return data;
    // Returns: { items: [...], objects: { total, count }, extra: {} }
  },

  async getTaskFilters() {
    const resp = await rockApi.get("/rocks/identify-tasks/filters");
    return unwrapRockResponse(resp);
  },

  async getTaskDetail(task_id) {
    const resp = await rockApi.get(`/rocks/identify-tasks/${task_id}`);
    const data = unwrapRockResponse(resp);
    return normalizeV1TaskStatus(data);
  },

  async getV2TaskDetail(task_id) {
    const resp = await rockApi.get(`/rocks/identify-tasks/${task_id}/v2`);
    return unwrapRockResponse(resp);
  },

  async getTaskEvents(task_id) {
    const resp = await rockApi.get(`/rocks/identify-tasks/${task_id}/events`);
    return unwrapRockResponse(resp);
  }
};
